import styled from "styled-components";
import * as PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { parse, DATE_FORMATS } from "utils/Date";
import { isAdminOnly, isTooSoon } from "utils/Treatment";
import TreatmentRow from "./TreatmentRow";
import messages from "./messages";
import moment from "moment";

/**
 * Amount of days needed between now and an appointment to edit it.
 */
function TreatmentQuestions(props) {
  const maxIndex = props.treatments.length - 1;

  return (
    <Content id="treatmentQuestions">
      <Header data-testid="Header">
        <tr>
          {!props.screenWidth && (
            <>
              <th width="35%">
                <FormattedMessage {...messages.treatment} />
              </th>
              <th>
                <FormattedMessage {...messages.duration} />
              </th>
              <th>
                <FormattedMessage {...messages.plannedDate} />
              </th>
              <th />
              <th>
                <FormattedMessage {...messages.productUpperJaw} />
              </th>
              <th>
                <FormattedMessage {...messages.productLowerJaw} />
              </th>
            </>
          )}
        </tr>
      </Header>
      <tbody>
        {props.treatments.map((treatment, index) => {
          let past = false;
          let adminOnly = false;
          // Check if the date is too soon to be edited.
          if (treatment.planned && treatment.planned_date_time_from) {
            const date = parse(
              treatment.planned_date_time_from,
              DATE_FORMATS.BUMBAL,
            );
            past = date.isBefore(moment(), "d");
            adminOnly = isAdminOnly(treatment);
          }
          return (
            <TreatmentRow
              adminOnly={adminOnly}
              tooSoon={isTooSoon(treatment)}
              past={past}
              showPrevious={index > 0}
              active={treatment.id === props.activeId}
              onEdit={props.onEdit}
              onSkip={props.onSkip}
              onPrevious={props.onPrevious}
              onDelete={props.onDelete}
              onExtraTreatment={props.onExtraTreatment}
              key={treatment.id}
              index={index}
              treatment={treatment}
              noDivider={index >= maxIndex}
              noSkip={index >= maxIndex}
              wagnerButton={props.wagnerItem && index === 0}
              wagnerActive={props.wagnerActive}
              screenWidth={props.screenWidth}
            />
          );
        })}
      </tbody>
    </Content>
  );
}

TreatmentQuestions.propTypes = {
  treatments: PropTypes.array.isRequired,
  activeId: PropTypes.number.isRequired,
  wagnerItem: PropTypes.any,
  wagnerActive: PropTypes.bool,

  // Handlers
  onEdit: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onExtraTreatment: PropTypes.func.isRequired,
  screenWidth: PropTypes.bool,
};

export default TreatmentQuestions;

const Content = styled.table`
  width: 100%;
`;

const Header = styled.thead`
  tr {
    th {
      text-align: left;
      padding-left: ${({ theme }) => theme.padding}rem;
    }
  }
`;
